import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '@/pages/home/components/Navbar';
import Footer from '@/pages/home/components/Footer';

const ORDER_NUM = () => `NP-${Date.now().toString().slice(-8)}`;

const CheckoutSuccess = () => {
  const [orderNum] = useState(ORDER_NUM);
  const [show, setShow] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
    setTimeout(() => setShow(true), 100);
  }, []);

  return (
    <div className="min-h-screen" style={{ background: '#05050a' }}>
      <Navbar />

      <div className="pt-28 pb-20 px-6 lg:px-12 flex items-center justify-center min-h-screen">
        <div
          className="max-w-lg w-full text-center transition-all duration-700"
          style={{ opacity: show ? 1 : 0, transform: show ? 'translateY(0)' : 'translateY(20px)' }}
        >
          {/* Success icon */}
          <div className="relative mx-auto mb-8" style={{ width: '100px', height: '100px' }}>
            <div
              className="w-full h-full rounded-full flex items-center justify-center"
              style={{ background: 'rgba(57,255,20,0.1)', border: '2px solid rgba(57,255,20,0.3)', boxShadow: '0 0 40px rgba(57,255,20,0.3)' }}
            >
              <i className="ri-check-line text-4xl" style={{ color: '#39ff14' }} />
            </div>
            {/* Pulse rings */}
            <div className="absolute inset-0 rounded-full animate-ping" style={{ background: 'rgba(57,255,20,0.08)' }} />
          </div>

          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full mb-4 font-mono text-xs" style={{ background: 'rgba(57,255,20,0.08)', border: '1px solid rgba(57,255,20,0.2)', color: '#39ff14' }}>
            <i className="ri-checkbox-circle-line" />
            ЗАКАЗ ОФОРМЛЕН
          </div>

          <h1 className="font-orbitron font-black text-3xl md:text-4xl text-white mb-3">
            Спасибо за <span style={{ color: '#39ff14', textShadow: '0 0 20px rgba(57,255,20,0.4)' }}>заказ!</span>
          </h1>

          <p className="font-mono text-sm mb-2" style={{ color: 'rgba(255,255,255,0.45)' }}>
            Ваш заказ успешно оформлен и передан в обработку
          </p>

          {/* Order number */}
          <div className="inline-flex items-center gap-2 px-5 py-3 rounded-xl mb-8" style={{ background: 'rgba(255,45,120,0.08)', border: '1px solid rgba(255,45,120,0.2)' }}>
            <i className="ri-file-list-3-line" style={{ color: '#ff2d78' }} />
            <span className="font-mono text-sm" style={{ color: 'rgba(255,255,255,0.5)' }}>Номер заказа:</span>
            <span className="font-orbitron font-bold text-sm" style={{ color: '#ff2d78' }}>{orderNum}</span>
          </div>

          {/* Timeline */}
          <div className="text-left p-5 rounded-2xl mb-8 space-y-4" style={{ background: 'rgba(255,255,255,0.02)', border: '1px solid rgba(255,255,255,0.07)' }}>
            <p className="font-orbitron font-bold text-xs text-white mb-4">Что дальше?</p>
            {[
              { icon: 'ri-mail-check-line', color: '#00f5ff', title: 'Подтверждение на email', desc: 'Письмо с деталями заказа уже отправлено', done: true },
              { icon: 'ri-store-2-line', color: '#f0ff00', title: 'Сборка заказа', desc: 'Фармацевт подготовит ваш заказ в течение 30 минут', done: false },
              { icon: 'ri-truck-line', color: '#ff2d78', title: 'Доставка', desc: 'Курьер доставит заказ в течение 2–4 часов', done: false },
            ].map((s, i) => (
              <div key={i} className="flex items-start gap-3">
                <div className="w-8 h-8 flex items-center justify-center rounded-full shrink-0" style={{ background: s.done ? `${s.color}20` : 'rgba(255,255,255,0.04)', border: `1px solid ${s.done ? s.color + '40' : 'rgba(255,255,255,0.08)'}` }}>
                  <i className={`${s.icon} text-sm`} style={{ color: s.done ? s.color : 'rgba(255,255,255,0.25)' }} />
                </div>
                <div>
                  <p className="font-mono text-xs text-white">{s.title}</p>
                  <p className="font-mono text-[10px]" style={{ color: 'rgba(255,255,255,0.35)' }}>{s.desc}</p>
                </div>
                {s.done && <i className="ri-check-line ml-auto shrink-0" style={{ color: '#39ff14' }} />}
              </div>
            ))}
          </div>

          {/* Actions */}
          <div className="flex flex-col sm:flex-row gap-3">
            <Link
              to="/profile"
              className="whitespace-nowrap flex-1 flex items-center justify-center gap-2 py-3 rounded-xl font-orbitron font-bold text-sm cursor-pointer transition-all duration-300"
              style={{ background: '#ff2d78', color: '#fff', boxShadow: '0 0 15px rgba(255,45,120,0.35)' }}
            >
              <i className="ri-file-list-3-line" />
              Мои заказы
            </Link>
            <Link
              to="/catalog"
              className="whitespace-nowrap flex-1 flex items-center justify-center gap-2 py-3 rounded-xl font-mono text-sm cursor-pointer transition-all duration-200"
              style={{ border: '1px solid rgba(255,255,255,0.1)', color: 'rgba(255,255,255,0.6)' }}
              onMouseEnter={e => { (e.currentTarget as HTMLElement).style.borderColor = 'rgba(255,255,255,0.25)'; (e.currentTarget as HTMLElement).style.color = '#fff'; }}
              onMouseLeave={e => { (e.currentTarget as HTMLElement).style.borderColor = 'rgba(255,255,255,0.1)'; (e.currentTarget as HTMLElement).style.color = 'rgba(255,255,255,0.6)'; }}
            >
              <i className="ri-medicine-bottle-line" />
              Продолжить покупки
            </Link>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default CheckoutSuccess;
